/* global axios */
import ApiClient from './ApiClient';

// NOTICE: KAPTION-INTEGRATION
// Rumo MCP session binding — mint an account+scope-bound grant after a fresh
// WhatsApp 2FA code. See Api::V1::Profile::KaptionMcpGrantsController.
class KaptionMcpGrantAPI extends ApiClient {
  constructor() {
    super('profile/kaption_mcp_grant', { accountScoped: false });
  }

  // NOTICE: KAPTION-INTEGRATION - ai-connectors.CONSENT.1: works before 2FA
  getStatus() {
    return axios.get(`${this.url}/status`);
  }

  getScopes() {
    return axios.get(`${this.url}/scopes`);
  }

  requestCode() {
    return axios.post(`${this.url}/request_code`);
  }

  // NOTICE: KAPTION-INTEGRATION - two-step-verification.WA.3: confirm with a passkey
  passkeyOptions() {
    return axios.post(`${this.url}/passkey_options`);
  }

  createGrant({
    accountId,
    accountIds,
    allAccounts,
    roles,
    scopes,
    code,
    oreq,
    clientName,
    // NOTICE: KAPTION-INTEGRATION - two-step-verification.WA.3: which proof
    // (whatsapp | authenticator | passkey); absent = WhatsApp code, as before.
    method,
    passkeyCredential,
  }) {
    return axios.post(this.url, {
      account_id: accountId,
      account_ids: accountIds,
      all_accounts: allAccounts,
      roles,
      scopes,
      code,
      oreq,
      client_name: clientName,
      ...(method ? { method } : {}),
      ...(passkeyCredential ? { passkey_credential: passkeyCredential } : {}),
    });
  }
}

export default new KaptionMcpGrantAPI();
